import { BalanceAge } from "api/responses";

/** Map each balance-aging enumeration value to some information about it, including its ordinal index and title. */
export const balanceMap = Object.freeze({
    [BalanceAge.ZeroToThirty]: { index: 0, title: "0\u201330" },
    [BalanceAge.ThirtyToSixty]: { index: 1, title: "31\u201360" },
    [BalanceAge.SixtyToNinety]: { index: 2, title: "61\u201390" },
    [BalanceAge.NinetyPlus]: { index: 3, title: "90+" },
});

/** Array of balance-aging enumeration values in their natural ascending order. */
export const balanceAges = Object.freeze([
    BalanceAge.ZeroToThirty,
    BalanceAge.ThirtyToSixty,
    BalanceAge.SixtyToNinety,
    BalanceAge.NinetyPlus,
]);
